module.exports = __webpack_public_path__ + "static/media/logotipo-iflares-transparencia-sanitaria.9dc2c9aa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/complex/cleanlocal/images/logotipo-iflares-transparencia-sanitaria.svg
// module id = 2183
// module chunks = 1